import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { KitStatusFragment } from "@graphql";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";

import moment from "moment";
import locale from "@bonliva-crm/locale";
import { DoneAll, HighlightOff } from "@material-ui/icons";
import { BookingKitStatusType } from "@bonliva-crm/shared";

type Props = {
  statuses: KitStatusFragment[];
  checkWasValid: boolean;
};

const rejectedStatuses = [
  BookingKitStatusType.RejectedByFinance,
  BookingKitStatusType.RejectedByFinanceInvoicing,
  BookingKitStatusType.RejectedByFinancePayment,
  BookingKitStatusType.RejectedByHBA,
  BookingKitStatusType.RejectedByOC,
  BookingKitStatusType.Deleted
];

export const BookingKitStatus = ({ statuses, checkWasValid }: Props) => {
  const classes = useStyles();

  return (
    <div>
      <Timeline align="left" style={{ margin: 0 }}>
        {statuses?.map(({ setBy, setOn, status, comment }, index) => (
          <TimelineItem key={index} className={classes.item}>
            <TimelineSeparator>
              <TimelineDot
                color={"primary"}
                className={`${classes.connector} ${
                  rejectedStatuses.includes(status) ? "reject" : ""
                }`}
              />
              {index < statuses.length - 1 && (
                <TimelineConnector
                // className={classes.connector}
                />
              )}
            </TimelineSeparator>
            <TimelineContent>
              <div>
                <div>
                  {locale.bookingKitStatusType[status]}
                  <Typography variant="subtitle2">{setBy?.Name}</Typography>
                  <Typography variant="caption">
                    {setOn ? moment(setOn).format("HH:mm DD/MM/YY") : ""}
                  </Typography>
                  {index === 0 && checkWasValid !== null && (
                    <Typography
                      variant="caption"
                      className={classes.doubleCheckAtCreationTime}
                    >
                      {locale.DoubleCheckAtCreationTime}
                      {checkWasValid ? (
                        <DoneAll fontSize={"small"} color={"secondary"} />
                      ) : (
                        <HighlightOff fontSize={"small"} color={"primary"} />
                      )}
                    </Typography>
                  )}
                </div>
                <Typography variant="body1">{comment}</Typography>
              </div>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  item: {
    "&&::before": {
      display: "none"
    }
  },
  doubleCheckAtCreationTime: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  },
  connector: {
    boxShadow: "none",
    backgroundColor: theme.palette.success.main,
    "&.reject": {
      backgroundColor: theme.palette.error.main
    }
  }
}));
